const parseId = (value: string[] | string | undefined): number | undefined => {
  if (value === undefined) return undefined;

  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? undefined : numberValue;
};

export default parseId;
